(ns teamoesterreich.admin-mode.lebensretter.detail.region-part

  (:require [clojure.string]
            [teamoesterreich.text.get-text :as txt]
            [reagent.core :as r]
            [reagent-material-ui.components :as mui]
            [goog.date.DateTime]
            [teamoesterreich.util.log :as log]
            ))

;(in-ns 'teamoesterreich.admin-mode.lebensretter.detail.region-part)


(defn region-form-lr [!region region]
  (let [selected @!region]
    [mui/card-content
     [mui/grid
      {:container  true
       :direction  "row"
       :justify    "flex-end"
       :alignItems "flex-end"
       :spacing    3
       }
      [mui/grid
       {:container false :item true
        :xs        3
        :style     {:padding 0}
        }
       [:h3 "Lebensretter Region"]
       ]
      [:div
       [mui/form-control-label
        {
         :style   {:background-color (if (and (not= (true? (get selected "all")) (true? (get region "all")))) "#ffd6d2" "transparent")}
         :control (r/as-element
                    [mui/checkbox {:color    "primary"
                                   :checked  (if (nil? (get selected "all")) (true? (get region "all")) (true? (get selected "all")))
                                   :onChange (fn [_ val]
                                               (let [reg selected
                                                     reg (assoc reg "all" val)
                                                     reg (reduce (fn [c e]
                                                                   (assoc c e val)) reg (remove #(= % "noAlert") (txt/txt :fake :lr-regions)))]
                                                 (log/debug "set new reg:" (clj->js reg))
                                                 (reset! !region reg)))
                                   }])

         }
        ]
       [:br]
       ]


      (for [R (remove #(= % "noAlert") (txt/txt :fake :lr-regions))]

        (let [R (str R)]
          ^{:key (str "region-" R)}
          [:div
           [mui/form-control-label
            {
             :style   {:background-color (if (and selected (not= (true? (get selected R)) (true? (get region R)))) "#ffd6d2" "transparent")}
             :control (r/as-element
                        [mui/checkbox {:readOnly true
                                       :color    "primary"
                                       :checked  (if (or (true? (get selected R)) (true? (get selected "all"))) true false)
                                       :onChange (fn [_ c] (swap! !region assoc R c "all" false))
                                       }])
             }
            ]
           [:br]
           [:span (str R)]
           ]
          ))


      [:div {:style {:borderLeft "1px solid black" :paddingLeft "5px"}}
       [mui/form-control-label
        {
         :style   {:background-color (if (and (not= (true? (get @!region "noAlert")) (true? (get region "noAlert")))) "#ffd6d2" "transparent")}
         :control (r/as-element
                    [mui/checkbox {:readOnly true
                                   :color    "primary"
                                   :checked  (or (true? (get @!region "noAlert")))
                                   :onChange (fn [_ c] (swap! !region assoc "noAlert" c))
                                   }])
         }
        ]
       [:br]
       [:span "Sperre"]
       ]

      ]
     ])

  )
(defn region-form-fr [!region region]
  (let [selected @!region]

    [mui/card-content
     [mui/grid
      {:container  true
       :direction  "row"
       :justify    "flex-end"
       :alignItems "flex-end"
       :spacing    3
       }
      [mui/grid
       {:container false :item true
        :xs        3
        :style     {:padding 0}
        }
       [:h3 "First Responder Region"]
       ]
      [:div
       [mui/form-control-label
        {
         :style   {:background-color (if (and (not= (true? (get selected "all")) (true? (get region "all")))) "#ffd6d2" "transparent")}
         :control (r/as-element
                    [mui/checkbox {:color    "primary"
                                   :checked  (if (nil? (get selected "all")) (true? (get region "all")) (true? (get selected "all")))
                                   :onChange (fn [_ val]
                                               (let [reg selected
                                                     reg (assoc reg "all" val)
                                                     reg (reduce (fn [c e]
                                                                   (assoc c e val)) reg (remove #(= % "noAlert") (txt/txt :fake :lr-regions)))]
                                                 (log/debug "set new reg:" (clj->js reg))
                                                 (reset! !region reg)))
                                   }])
         }
        ]
       [:br]
       ]


      (for [R (remove #(= % "noAlert") (txt/txt :fake :lr-regions))]
        (let [R (str R)]
          ^{:key (str "region-" R)}
          [:div
           [mui/form-control-label
            {
             :style   {:background-color (if (and selected (not= (true? (get selected R)) (true? (get region R)))) "#ffd6d2" "transparent")}
             :control (r/as-element
                        [mui/checkbox {:readOnly true
                                       :color    "primary"
                                       :checked  (if (or (true? (get selected R)) (true? (get selected "all"))) true false)
                                       :onChange (fn [_ c] (swap! !region assoc R c "all" false))
                                       }])
             }
            ]
           [:br]
           [:span (str R)]
           ]
          ))


      [:div {:style {:borderLeft "1px solid black" :paddingLeft "5px"}}
       [mui/form-control-label
        {
         :style   {:background-color (if (and (not= (true? (get @!region "noAlert")) (true? (get region "noAlert")))) "#ffd6d2" "transparent")}
         :control (r/as-element
                    [mui/checkbox {:readOnly true
                                   :color    "primary"
                                   :checked  (or (true? (get @!region "noAlert")))
                                   :onChange (fn [_ c] (swap! !region assoc "noAlert" c))
                                   }])
         }
        ]
       [:br]
       [:span "Sperre"]
       ]
      ]

     ])

  )

(defn region-view [lr-clearance]
  (let [region (reduce (fn [c e] (assoc c e true)) {} (clojure.string/split (:lrClearance-lrRegionHack lr-clearance) #"\|"))]
    [:div
     (for [R (remove #(= % "noAlert") (txt/txt :fake :lr-regions))]
       (if (or (get region "all") (get region R))
         ^{:key (str "region-" R)}
         [mui/chip {:label R :style {:marginLeft "10px"}}]))
     (when (get region "noAlert") [mui/chip {:label "Sperre" :style {:marginLeft "10px"}}])

     ]
    ))

(defn fr-region-view [lr-clearance]
  (let [region (reduce (fn [c e] (assoc c e true)) {} (clojure.string/split (:lrClearance-frRegionHack lr-clearance) #"\|"))]
    [:div
     (for [R (remove #(= % "noAlert") (txt/txt :fake :lr-regions))]
       (if (or (get region "all") (get region R))
         ^{:key (str "region-" R)}
         [mui/chip {:label R :style {:marginLeft "10px"}}]))
     (when (get region "noAlert") [mui/chip {:label "Sperre " :style {:marginLeft "10px"}}])

     ]
    ))


